export const TREE_ITEM_TOOLTIP_ID = 'tree-item-label-tooltip';
